import React from 'react';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';
import { Picker, Switch } from 'antd-mobile';

import './CommunityPublish.less';

var isSubmiting = false;

var routeIsCommunityPage = function () {
  return /^informationManagement/.test(app.getAppCurrentPage().route);
}

export class CommunityPublish extends CommonComponent {
  constructor(props) {
    super(props);

    this.state = {
      communityPublish: {
        show: false,
        publishType: 0,
        detail: '',
        articleId: '',
        from: '',
        franchisee: '',
        reqAudit: ''
      },
      communityId: '',
      articleData : {
        title : '',
        text: '',
        imgs : [],
        section_id: '',
        category_id: '',
        phone: '',
        latitude: '',
        longitude: '',
        type: 0,
        origin_url: ''
      },
      address: '',
      theme_color : '',
      selectedClassify: '',
      require_audit: '',
      require_loc: true,
      require_phone: true,
      fromCommunityPage: false,
      showSlectWindow: false,
      showClassifyBox: false,
      showCategoryList: false,
      selectedSectionIndex: '',
      selectedSectionName: '',
      sectionList: [],
      selectedCategoryIndex: '',
      selectedCategoryName: '',
      categoryList: [],
      showTopWrap: false,
      selectedTime: [],
      selectedTimeIndex: 0,
      isShowTop: false,
    }
  }

  componentDidMount(){
    
  }

  show = (options) => {
    let defaultValue = {
      publishType: 0,
      detail: '',
      articleId: '',
      from: '',
      franchisee: '',
      reqAudit: ''
    },
    newOptions = Object.assign({}, defaultValue, options.communityPublish);
    this.setData({
      communityPublish : newOptions
    });
    this.init(newOptions);
  }

  init = (options) => {
    let that = this;
    let {
      publishType,
      detail,
      articleId,
      from,
      franchisee,
      reqAudit
    } = options;
    isSubmiting = false;

    app.getStorage({
      key: 'communityThemeColor-' + detail,
      success: function (res) {
        that.setData({ theme_color: res.data });
      }
    })

    this.setData({
      'communityId': detail || '',
      'articleId': articleId || '',
      'require_audit': reqAudit || '',
      'articleData.section_id': detail || '',
      'fromCommunityPage': from || '',
      'type': publishType == 2 ? 'link' : 'default',
      'articleData.type': publishType,
      'franchisee': franchisee || '',
      showTopWrap: false,
      selectedTime: [],
      selectedTimeIndex: 0,
      isShowTop: false,
      isBuyTop: false,
      topOrderInfo: {}
    });

    if (articleId) {
      this.getArticle(articleId);
    } else {
      this.getSections(detail);
    }
  }

  submitData = (event) => {
    let that = this,
      articleData = this.data.articleData,
      title = articleData.title,
      text = articleData.text,
      need_loc = that.data.require_loc,
      need_phone = that.data.require_phone,
      latitude = need_loc ? articleData.latitude : '',
      longitude = need_loc ? articleData.longitude : '',
      address = need_loc ? that.data.address : '',
      phone = need_phone ? articleData.phone : '',
      communityId = this.data.communityId || articleData.section_id,
      categoryId = articleData.category_id,
      type = articleData.type || 0,
      origin_url = articleData.origin_url || articleData.origin_url || '';


    if (!title) {
      app.showModal({ content: '请填写标题' });
      return;
    } else if (title.length > 46) {
      app.showModal({ content: '标题字数不得超过46' });
      return;
    } else { }

    if (this.data.type == 'default') {
      if (!text) {
        app.showModal({ content: '请填写话题内容' });
        return;
      }
    } else if (this.data.type == 'link') {
      if (!origin_url) {
        app.showModal({ content: '请粘贴公众号文章或腾讯视频链接' });
        return;
      }
    } else { }
    if (!this.data.selectedSectionName || !this.data.selectedCategoryName) {
      app.showModal({ content: '请选择分类' });
      return;
    }

    let url = '/index.php?r=AppSNS/AddArticle';
    let article_id = that.data.articleId;

    if (article_id) {
      url = '/index.php?r=AppSNS/UpdateArticle';
    }

    if (isSubmiting) {
      app.showModal({
        content: '正在提交中，请勿重复点击',
        complete: function () {
          !isSubmiting && that.returnBack();
        }
      });
      return;
    }
    isSubmiting = true;

    let submitParams = {
      audit_status: 2,
      article_id: article_id,
      section_id: communityId || this.data.sectionList[this.data.selectedSectionIndex].id, //版块id
      category_id: categoryId || this.data.categoryList[this.data.selectedCategoryIndex].id, //分类id 可不传
      title: title,
      text: text,
      imgs: articleData.imgs,
      is_carousel: 0, //是否开启轮播 1为开启 0不开启
      top_flag: 0, //是否置顶 1为置顶 0不置顶
      hot_flag: 0, //是否精品 1是 0否
      phone: phone,
      latitude: latitude,
      longitude: longitude,
      address: address,
      type: type,
      origin_url: origin_url,
      sub_app_id: that.data.franchisee
    }

    if (articleData.imgs.length > 0) {
      that.wxImgsCheck(articleData.imgs)
        .then(function () {
          that.afterCheckSubmitData(url, submitParams);
        }, function (res) {
          app.showModal({ content: res && res.data || '网络错误或图片审核不通过' });
          isSubmiting = false;
        });
    } else {
      if (type == 2) {
        that.checkGrabLinkIsOk(origin_url).then(function (res) {
          if (!!res.unSupportable) {
            app.showModal({
              title: '提示',
              content: res.data || '暂不支持抓取含音频|视频|投票|小程序的图文文章',
              showCancel: true,
              confirmText: '继续',
              cancelText: '放弃',
              confirm: function () {
                that.afterCheckSubmitData(url, submitParams);
              },
              cancel: function () {
                isSubmiting = false;
              }
            });
          } else {
            that.afterCheckSubmitData(url, submitParams);
          }
        }, function () {
          isSubmiting = false;
        });
      } else {
        that.afterCheckSubmitData(url, submitParams);
      }
    }
  }

  afterCheckSubmitData = (url, data) => {
    let that = this;
    if (that.data.isShowTop && !that.data.isBuyTop){
      data.topTime = that.data.selectedTime[that.data.selectedTimeIndex].days;
      data.topPrice = that.data.selectedTime[that.data.selectedTimeIndex].price;
      app.sendRequest({
        url: '/index.php?r=AppSNS/AddSectionOrder',
        data: {
          days: that.data.selectedTime[that.data.selectedTimeIndex].days,
          section_id: that.data.communityId
        },
        method: 'post',
        success: function (res) {
          let param = res.data;
          param.success = function () {
            data.order_id = res.order_id;
            that.afterPaySubmitData(url, data);
          };
          param.fail = function (res1) {
            isSubmiting = false;
          }
          app.wxPay(param);
        },
        fail: function () {
          isSubmiting = false;
        }
      })
    }else{
      that.afterPaySubmitData(url, data);
    }
  }

  afterPaySubmitData = (url, data) => {
    let that = this;
    app.sendRequest({
      url: url,
      data: data,
      method: 'post',
      success: function (res) {
        let content = that.data.require_audit == 1 ? '提交成功，待审核。' : '提交成功';
        if (that.data.require_audit == 1 && data.topTime){
          content = "提交成功，待审核。审核如果失败，置顶费用将原路返回";
        }
        app.showModal({
          content: content,
          confirm: function () {
            that.setData({
              'articleData.title' : '',
              'articleData.text': ''
            })
            that.returnBack();
            if (routeIsCommunityPage()) {
              app.globalData.communityPageRefresh = true;
            } else {
              app.globalData.topicRefresh = true;
            }
            // app.onPageShow(); // 主动刷新页面
            window.location.reload(); //TODO：暂时这样处理
          }
        });
        app.globalData.communityPageRefresh = true;
        app.globalData.communityUsercenterRefresh = true;
      },
      complete: function (res) {
        isSubmiting = false;
      }
    });
  }

  bindTitleInput = (event) => {
    let val = event.target.value;

    this.setData({
      'articleData.title': val
    })
  }

  bindTextInput = (event) => {
    let val = event.target.value;

    this.setData({
      'articleData.text': val,
      'articleData.viewtext': val.replace(/\\n/g, '\n')
    });
  }

  bindTextBlur = (event) => {
    let val = event.target.value;

    this.setData({
      'articleData.text': val,
      'articleData.viewtext': val.replace(/\\n/g, '\n')
    });
  }

  bindPhoneInput = (event) => {
    let val = event.target.value;

    this.setData({
      'articleData.phone': val
    })
  }

  bindPhoneBlur = (event) => {
    let val = event.target.value;
    this.setData({ 'articleData.phone': val });
  }

  uploadImg = () => {
    var that = this,
      imgs = that.data.articleData.imgs;

    app.chooseImage(function (imageUrls) {
      imgs = imgs.concat(imageUrls);
      that.setData({
        'articleData.imgs': imgs
      });
    }, 9);
  }

  deleteImg = (event) => {
    var index = event.currentTarget.dataset.index,
      imgs = this.data.articleData.imgs;

    imgs.splice(index, 1);
    this.setData({
      'articleData.imgs': imgs
    });
  }

  getSections = (communityId, callback) => {
    var that = this,
      param = {
        page: -1,
        sub_app_id: that.data.franchisee
      };
    if (communityId) {
      param.page = 1;
      param.section_id = communityId;
    }
    app.sendRequest({
      url: '/index.php?r=AppSNS/GetSectionByPage',
      data: param,
      method: 'post',
      success: function (res) {
        let newdata = {};
        let sec = res.data[0];
        newdata.require_loc = sec.require_location == 1;
        newdata.require_phone = sec.require_phone == 1;
        if (!that.data.theme_color) {
          newdata.theme_color = sec.theme_color;
        }
        if (communityId) {
          newdata['selectedSectionName'] = sec.name;
          newdata['require_audit'] = sec.require_audit;
          newdata['showCategoryList'] = true;
          newdata.showTopWrap = res.data[0].price_set ? true : false;
          newdata.selectedTime = res.data[0].price_set ? res.data[0].price_set : {};
        }
        newdata['sectionList'] = res.data;
        that.setData(newdata);
        that.getCategory(communityId || res.data[0].id);
        typeof callback == 'function' && callback(res.data);
      }
    });
  }

  getCategory = (sectionId, callback) => {
    var that = this;
    app.sendRequest({
      url: '/index.php?r=AppSNS/GetCategoryByPage',
      data: {
        section_id: sectionId || that.data.communityId,
        page: -1,
        page_size: 100,
        sub_app_id: that.data.franchisee
      },
      method: 'post',
      success: function (res) {
        if (res.status == 0) {
          let info = res.data,
            newdata = [{ id: '', name: '全部(默认)' }].concat(info);
          that.setData({ 'categoryList': newdata });
          typeof callback == 'function' && callback(newdata);
        }
      }
    });
  }

  getArticle = (article_id) => {
    var that = this;
    app.sendRequest({
      url: '/index.php?r=AppSNS/GetArticleByPage',
      data: {
        article_id: article_id,
        only_own_record: 1,
        sub_app_id: that.data.franchisee
      },
      method: 'post',
      success: function (res) {
        if (res.status == 0) {
          let info = res.data[0],
            newdata = {};

          newdata['communityId'] = info.section_id;
          newdata['articleData.title'] = info.title;
          newdata['articleData.text'] = info.content.text;
          newdata['articleData.viewtext'] = info.content.text.replace(/\\n/, '\n');
          newdata['articleData.imgs'] = info.content.imgs || [];
          newdata['articleData.phone'] = info.phone;
          newdata['articleData.section_id'] = info.section_id;
          newdata['articleData.category_id'] = info.category_id;
          newdata['articleData.latitude'] = info.latitude;
          newdata['articleData.longitude'] = info.longitude;
          newdata['articleData.origin_url'] = info.content.origin_url;
          newdata['articleData.view_origin_url'] = info.content.origin_url.replace(/\\n/, '\n');
          newdata['address'] = info.address;
          newdata['isBuyTop'] = !!info.is_paid_article;
          newdata['isShowTop'] = !!info.is_paid_article;
          newdata['topOrderInfo'] = info.order_info;

          // that.getLocByLatAndLng(info.latitude, info.longitude, function (data) {
          //   that.setData({ address: data.address });
          // })

          that.getSections(info.section_id);
          that.getCategory(info.section_id, function (data) {
            data.some((cate, cateIdx) => {
              that.setData({
                'selectedCategoryIndex': cateIdx,
                'selectedCategoryName': cate.name,
                'showCategoryList': true
              });
            });
          });

          that.setData(newdata);
        }
      }
    });
  }

  getAddress = () => {
    let that = this;
    app.chooseLocation({
      success: function (res) {
        if (!res.longitude) {
          app.showModal({
            content: '请选择具体的地址'
          });
          return;
        }
        that.setData({
          'articleData.latitude': res.latitude,
          'articleData.longitude': res.longitude,
          'address': res.address || ''
        });
        if (!res.address) {
          that.getLocByLatAndLng(res.latitude, res.longitude, function (data) {
            that.setData({ address: data.address });
          })
        }
      }
    })
  }

  addressInput = (event) => {
    if (event.target.value) {
      this.setData({
        'articleData.latitude': '',
        'articleData.longitude': '',
        'address': ''
      });
    }
  }

  getLocByLatAndLng = (lat, lng, cb) => {
    app.sendRequest({
      url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
      data: {
        latitude: lat,
        longitude: lng
      },
      method: 'post',
      success: function (data) {
        if (data.status == 0 && typeof cb == 'function') {
          cb(data.data);
        }
      }
    })
  }

  showClassifyBox = () => {
    let showFlag = this.data.showClassifyBox;
    this.setData({ showClassifyBox: !showFlag });
    if (!this.data.articleData.category_id) {
      this.setData({
        'articleData.category_id': 0,
        selectedClassify: '全部（默认）'
      });
    }
  }

  showSlectWindowAct = () => {
    if (this.data.showSlectWindow && this.data.selectedCategoryName && !this.data.showCategoryList) {
      this.setData({
        'showCategoryList': true
      });
    }
    this.setData({
      'showSlectWindow': !this.data.showSlectWindow
    });
  }

  selectSectionAct = (e) => {
    let currentTarget = e.currentTarget,
      dataset = currentTarget.dataset,
      secIndex = dataset.index,
      currentSection = this.data.sectionList[secIndex];
    this.setData({
      'selectedSectionIndex': secIndex,
      'selectedSectionName': currentSection.name,
      'require_audit': currentSection.require_audit,
      'require_loc': currentSection.require_location == 1,
      'require_phone': currentSection.require_phone == 1,
      'showTopWrap': currentSection.price_set ? true : false,
      'selectedTime': currentSection.price_set || [],
      'communityId': currentSection.id,
      'selectedCategoryIndex': '',
      'selectedCategoryName': '',
      'showCategoryList': true
    });
    this.getCategory(currentSection.id);
  }

  selectCategoryAct = (e) => {
    let currentTarget = e.currentTarget,
      dataset = currentTarget.dataset,
      cateIndex = dataset.index,
      currentCategory = this.data.categoryList[cateIndex];
    this.setData({
      'selectedCategoryIndex': cateIndex,
      'selectedCategoryName': currentCategory.name,
      'showSlectWindow': false
    });
  }

  changeShowListAct = () => {
    if (this.data.fromCommunityPage) {
      return;
    }
    this.setData({
      'showCategoryList': !this.data.showCategoryList
    });
  }

  stopPropagation = (event) => {
    event.stopPropagation();
  }

  bindTextFocus = () => {
    this.data.showSlectWindow && this.showSlectWindowAct();
  }

  bindLinkInput = (e) => {
    let articlelinkInput = e.target.value;
    this.setData({
      'articleData.origin_url': articlelinkInput,
      'articleData.view_origin_url': articlelinkInput.replace(/\\n/g, '\n')
    });
  }

  bindLinkBlur = (e) => {
    let articlelink = e.target.value;
    this.setData({
      'articleData.origin_url': articlelink,
      'articleData.view_origin_url': articlelink.replace(/\\n/g, '\n')
    });
  }
  
  imgCheck = (img) => {
    return new Promise(function (resolve, reject) {
      app.sendRequest({
        url: '/index.php?r=AppShop/ImgSecCheck',
        data: { imgs: [img] },
        method: 'post',
        success: function (res) {
          resolve(img);
        },
        complete: function (res) {
          if (!res || res.status != 0) {
            reject(res);
          }
        }
      })
    });
  }

  wxImgsCheck = (arr) => {
    return Promise.all(arr.map(img => this.imgCheck(img)));
  }

  checkGrabLinkIsOk = (url) => {
    return new Promise(function (resolve, reject) {
      app.sendRequest({
        url: '/index.php?r=AppShop/WechatUrlCheck',
        data: { url },
        method: 'post',
        success: function (res) {
          resolve(res);
        },
        complete: function (res) {
          if (!res || res.status != 0) {
            reject(res);
          }
        }
      });
    });
  }

  returnBack = () => {
    this.setData({
      'communityPublish.show': false,
      showCategoryList: false,
      articleData: {
        title: '',
        text: '',
        imgs: [],
        section_id: '',
        category_id: '',
        phone: '',
        latitude: '',
        longitude: '',
        type: 0,
        origin_url: '',
        viewtext: '',
        view_origin_url: ''
      },
      selectedSectionIndex: '',
      selectedSectionName: '',
      selectedCategoryIndex: '',
      selectedCategoryName: '',
      address: ''
    });
  }

  chooseTopTime = (e) => {
    this.setData({
      selectedTimeIndex: e.target.value
    })
  }

  toSetingTop = (e) => {
    this.setData({
      isShowTop: e.target.value
    })
  }

  submitRegion= (e) => {
    this.setData({
      selectedTimeIndex: e.target.value
    })
  }


  render(){
    let {
      communityPublish,
      type,
      require_loc,
      require_phone,
      showClassifyBox,
      articleData,
      address,
      theme_color,
      selectedSectionName,
      selectedCategoryName,
      showTopWrap,
      isShowTop,
      isBuyTop,
      showSlectWindow,
      showCategoryList,
      categoryList,
      sectionList
    } = this.state;
    if(!communityPublish.show){
      return null;
    }
    return (
      <div className="common-component">
        <div className="communityPublish-wrap" id="communityPublish">
          <div className="communityPublish-main" style={require_loc ? {paddingBottom: 0} : {}}>
            <div className="communityPublish-title">
              <input className={`communityPublish-title-input ${showClassifyBox ? 'hide' : ''}`} id="communityPublish-title-input" placeholder="请输入标题" placeholder-style="color:#6e6e6e;font-size:14px;" type="text" onInput={this.bindTitleInput} onChange={this.bindTitleInput} value={articleData.title} />
            </div>
            {
              type == 'default' && (
                <div className="communityPublish-content">
                  <textarea className={`communityPublish-content-input ${showClassifyBox ? 'hide' : ''}`} id="communityPublish-content-input" placeholder="请输入内容..." placeholder-style="color:#6e6e6e;font-size:12px;" onInput={this.bindTextInput} onChange={this.bindTextInput} value={articleData.text} />
                </div>
              )
            }
            {
              type == 'link' && (
                <div className="communityPublish-content">
                  <textarea className={`communityPublish-content-input ${showClassifyBox ? 'hide' : ''}`} id="communityPublish-content-input" placeholder="请粘贴公众号文章或链接" placeholder-style="color:#6e6e6e;font-size:12px;"  onInput={this.bindLinkInput} onChange={this.bindLinkInput} value={articleData.origin_url} />
                </div>
              )
            }
            {
              type == 'default' && (
                <div className="communityPublish-img-wrap">
                  <div className="communityPublish-ul clearfix" id="communityPublish-ul">
                    {
                      articleData.imgs && articleData.imgs.map((item, index) => (
                        <div key={index} className="communityPublish-item">
                          <img className="communityPublish-upload-image" src={item} mode="aspectFill" />
                          <div className="communityPublish-item-delete" data-index={index} onClick={this.deleteImg}>×</div>
                        </div>
                      ))
                    }
                    <div className="communityPublish-item-add" onClick={this.uploadImg}><label className="add-label">+</label></div>
                  </div>
                </div>
              )
            }
            {
              require_loc && (
                <div className="communityPublish-address" onClick={this.getAddress} >
                  <label className="communityPublish-address-label ico-moon icon-community-location" style={{color: address ? theme_color : ''}}></label>
                  <input className={`communityPublish-address-input ${showClassifyBox ? 'hide' : ''}`} id="communityPublish-address-input" placeholder="所在位置" placeholder-style="color:#6e6e6e;font-size:14px;" type="text" disabled={true} onChange={this.addressInput} value={address} />
                </div>
              )
            }
          </div>
          <div className="communityPublish-center">
            {
              require_phone && (
                <div className="communityPublish-piece communityPublish-phone">
                  <label className="communityPublish-piece-icon ico-moon icon-takeout-cellphone" style={{color: articleData.phone ? theme_color : ''}}></label>
                  <input className="communityPublish-phone-input" id="communityPublish-phone-input" placeholder="电话号码" placeholder-style="color:#6e6e6e;font-size:14px;" type="number" onInput={this.bindPhoneInput} onBlur={this.bindPhoneBlur} onChange={this.bindPhoneInput} value={articleData.phone} />
                </div>
              )
            }
            <div className="communityPublish-piece communityPublish-classify-title"><label className="communityPublish-piece-icon ico-moon icon-community-category" style={{color: selectedSectionName && selectedCategoryName ? theme_color : ''}}></label><span>选择分类</span></div>
            <div className="communityPublish-piece communityPublish-classify">
              {
                !selectedCategoryName ? (
                  <div className="communityPublish-classify-view communityPublish-select-classify" onClick={this.showSlectWindowAct}><span className="communityPublish-classify-text">请选择</span><label className="communityPublish-piece-icon ico-moon icon-filter-down"></label></div>
                ) : (
                  <div className="communityPublish-classify-view communityPublish-current-classify" onClick={this.showSlectWindowAct}><span className="communityPublish-classify-text">{selectedSectionName}</span>-<span className="communityPublish-classify-text">{selectedCategoryName}</span></div>
                )
              }
            </div>
          </div>
          {
            showTopWrap && (
              <div className="communityPublish-setTop">
                <div className="communityPublish-seting-top flex-wrap">
                  <div>我要置顶</div>
                  <Switch className="switch" color={isBuyTop ? '#dedede' : theme_color} disabled={isBuyTop} checked={isShowTop} onChange={this.toSetingTop}></Switch>
                </div>
                {
                  isShowTop && (
                    <React.Fragment>
                      <Picker mode='selector' disabled={isBuyTop} value={selectedIndex} data={selectedTime} cols={1} onChange={this.submitRegion}>
                        <div className='communityPublish-seting-time flex-wrap'>
                          <div>选择置顶时间</div>
                          <div style={isBuyTop ? {color: '#dedede'} : {}}>{isBuyTop ? topOrderInfo.days : selectedTime[selectedTimeIndex].days}天<div className='ico-moon icon-rightarrow'></div></div>
                        </div>
                      </Picker>
                      <div className='communityPublish-seting-money flex-wrap'>
                        <div>置顶费用</div>
                        <div>¥{selectedTime[selectedTimeIndex].price}</div>
                      </div>
                    </React.Fragment>
                  )
                }
              </div>
            )
          }

          <div className="communityPublish-foot">
            <button className="communityPublish-btn" onClick={this.submitData} style={{backgroundColor: theme_color}}>立即发布</button>
          </div>
          <div className="return-btn" onClick={this.returnBack}><label className="ico-moon icon-closes"></label></div>
        </div>
        {
          showSlectWindow && (
            <div className="communityPublish-classify-select-wrap" onClick={this.showSlectWindowAct}>
              <div className="communityPublish-catchtouchmove-layer"></div>
              <div className="communityPublish-classify-select-window" onClick={this.stopPropagation}>
                <div className="communityPublish-classify-select-top">
                  {
                    selectedSectionName && <span className="communityPublish-cst-text" onClick={this.changeShowListAct}>{selectedSectionName}</span>
                  }
                  {
                    selectedCategoryName && showCategoryList && <span className="communityPublish-cst-text">{selectedCategoryName}</span>
                  }
                  {
                    !selectedCategoryName && <span className="communityPublish-cst-text">{selectedSectionName ? '选择分类' : '请选择'}</span>
                  }
                </div>
                {
                  showCategoryList ? (
                    <div className="communityPublish-classify-select-list category-list">
                      {
                        categoryList && categoryList.map((cate, cateIdx) => (
                          <div key={cateIdx} className="communityPublish-classify-select-item" data-index={cateIdx} onClick={this.selectCategoryAct}><span className="communityPublish-csi-text">{cate.name}</span><label className="communityPublish-csi-icon ico-moon icon-rightarrow"></label></div>
                        ))
                      }
                    </div>
                  ) : (
                    <div className="communityPublish-classify-select-list section-list">
                      {
                        sectionList && sectionList.map((sec, secIdx) => (
                          <div className="communityPublish-classify-select-item" key={secIdx} data-index={secIdx} onClick={this.selectSectionAct}><img className="communityPublish-csi-image" src={sec.img} alt="" /><span className="communityPublish-csi-text">{sec.name}</span><label className="communityPublish-csi-icon ico-moon icon-rightarrow"></label></div>
                        ))
                      }
                    </div>
                  )
                }
              </div>
            </div>
          )
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/common/community-publish/CommunityPublish.jsx